import { Box } from '@mui/material';
import { RenderTable } from '../../../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  apiData: any;
  year: number;
}
const TController = ({ apiData, year }: IProps) => {
  const { defectsCountResult, defectsCountColumnResult, defectsName } = apiData;
  return (
    <Box>
      <RenderTable>
        <>
          <THead defectsName={defectsName} />
          {
            <TBody
              defectsCountResult={defectsCountResult}
              defectsCountColumnResult={defectsCountColumnResult}
            />
          }
          {/*<TFoot
            preparedBy={undefined}
            approvedBy={undefined} //preparedBy={moduleData.report_prepared_by}
            //approvedBy={moduleData.report_approved_by}
          />*/}
        </>
      </RenderTable>
    </Box>
  );
};

export default TController;
